import { Link } from "react-router-dom";
import { Github, Linkedin, Mail, ArrowUp } from "lucide-react";
import { personalInfo } from "../data/mock";

const socialLinks = [
  { icon: Github, href: personalInfo.github, label: "GitHub" },
  { icon: Linkedin, href: personalInfo.linkedin, label: "LinkedIn" },
  { icon: Mail, href: `mailto:${personalInfo.email}`, label: "Email" }
];

const quickLinks = [
  { to: "/about", label: "About" },
  { to: "/experience", label: "Experience" },
  { to: "/projects", label: "Projects" },
  { to: "/contact", label: "Contact" }
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 bg-ink border-t border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <h3 className="font-display text-xl font-bold text-fg">
              {personalInfo.name}
              <span className="text-signal">.</span>
            </h3>
            <p className="font-mono text-xs uppercase tracking-wider text-signal mt-1">
              Backend Engineer · ERP & Production Systems
            </p>
            <p className="text-fg-dim mt-5 max-w-md leading-relaxed">
              Building the backend and real-time systems that keep factory floors
              running — on the .NET stack, with clean architecture.
            </p>
            <div className="flex gap-3 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2.5 bg-panel border border-line rounded-md text-fg-mute hover:text-signal hover:border-signal/40 transition-colors"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-wider text-fg-mute mb-4">
              Navigate
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-fg-dim hover:text-signal transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-wider text-fg-mute mb-4">
              Contact
            </h4>
            <div className="space-y-2.5 text-fg-dim">
              <p className="break-all">{personalInfo.email}</p>
              <p>{personalInfo.location}</p>
            </div>
          </div>
        </div>

        <div className="rule my-10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-mono text-xs text-fg-mute">
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-fg-mute hover:text-signal transition-colors"
          >
            Back to top
            <ArrowUp className="w-3.5 h-3.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
